var React = require('react');

function SearchIconOpen (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"1.61985","height":"38.1823","transform":"matrix(-0.7075 0.706713 -0.7075 -0.706713 29 26.9844)","fill":"white","stroke":"white","key":0}),React.createElement("rect",{"width":"1.61986","height":"38.1823","transform":"matrix(0.706714 0.707499 -0.706714 0.707499 27.8538 0)","fill":"white","stroke":"white","key":1})]);
}

SearchIconOpen.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29","fill":"none"};

module.exports = SearchIconOpen;

SearchIconOpen.default = SearchIconOpen;
